export enum Plans  {
	MONTHLY = 11,
	ANNUAL = 1,
	QUARTERLY = 4
}
